import {Component, Inject, OnInit} from '@angular/core';
import {Localization} from "../../../../common/enums/localization";
import {NewTeamContactForm} from "./new-team-contact-form";
import {AppAvailableLanguagesService} from "../../../../../app-available-languages.service";
import {TranslateService} from "@ngx-translate/core";
import {IdAndLabel} from "../../../../common/model/id-and-label";
import {GenderType} from "../../../../common/enums/enums";
import {InterventionTeamContactResource} from "../intervention-team-contact-resource.service";
import {InterventionTeamContactDto} from "../intervention-team-contact.dto";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-new-team-contacct-dialog',
  templateUrl: './team-contact-dialog.component.html',
  styleUrls: ['./team-contact-dialog.component.scss']
})
export class TeamContactDialogComponent implements OnInit {

  public readonly Localization = Localization;
  public saving = false;
  public form = NewTeamContactForm.from(this.contact);
  public loadingLanguages = false;
  public languages: IdAndLabel[];
  public readonly genders = [
    new IdAndLabel(GenderType.FEMALE, 'Female'),
    new IdAndLabel(GenderType.MALE, 'Male'),
    new IdAndLabel(GenderType.X, 'X'),
  ];

  constructor(
    private readonly self: MatDialogRef<TeamContactDialogComponent>,
    private readonly availableLanguages: AppAvailableLanguagesService,
    private readonly translate: TranslateService,
    private readonly contactResource: InterventionTeamContactResource,
    @Inject(MAT_DIALOG_DATA)
    private readonly contact?: InterventionTeamContactDto,
  ) {
  }

  public get isEditing(): boolean {
    return !!this.contact?.id;
  }

  public get canSave(): boolean {
    return this.form.valid && this.form.dirty;
  }

  async ngOnInit(): Promise<void> {
    await this.fetchLanguages();
  }

  public async save(): Promise<void> {
    let persistedContact: InterventionTeamContactDto = {...this.contact, ...this.form.value};
    const saveOperation = this.isEditing ?
      this.contactResource.update(persistedContact) : this.contactResource.create(persistedContact);
    persistedContact = await saveOperation.toPromise();
    Object.assign(this.contact || {}, persistedContact);
    this.self.close(persistedContact as InterventionTeamContactDto);
  }

  public cancel(): void {
    this.self.close();
  }

  public async fetchLanguages() {
    this.loadingLanguages = true;
    const languages = await this.availableLanguages.getLanguages().toPromise();
    this.loadingLanguages = false;
    this.languages = languages.map(languageCode => new IdAndLabel(languageCode, this.translate.instant(`languageType_${languageCode}`)))
  }
}
